module.exports = __webpack_public_path__ + "static/media/CR.72b6a1a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CR.svg
// module id = 231
// module chunks = 0